import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// //
// Slice base configuration;
export interface EventsEntry {
    event_id?: string;
    name: string;
    message: string;
    type: "success" | "error" | "info" | "warning";
}

export interface IEventSlice {
    dialogAlerts: EventsEntry[]
}

// //
// Slice state calls
const createAlertEvent = (state: IEventSlice, { payload }: PayloadAction<EventsEntry>) => {
    if (!payload.event_id) {
        payload.event_id = "EVENT#" + payload.name + "#" + new Date().getTime()
    };

    const existingEventIndex = state.dialogAlerts.findIndex(event => event.event_id === payload.event_id);
    if (existingEventIndex !== -1) {
        // If event with the same ID exists, update it
        state.dialogAlerts[existingEventIndex] = payload;
        return;
    }
    state.dialogAlerts.push(payload);
}

const deleteAlertEvent = (state: IEventSlice, { payload }: PayloadAction<EventsEntry>) => {
    state.dialogAlerts = state.dialogAlerts.filter((event) => event.event_id !== payload.event_id);
}

const initialState = {
    dialogAlerts: []
};

const eventSlice = createSlice({
    name: 'event',
    initialState: initialState,
    reducers: {
        addAlertEvent: createAlertEvent,
        removeAlertEvent: deleteAlertEvent
    },
});

export const eventReducer = eventSlice.reducer;
export const eventActionProps = eventSlice.actions;
export const { addAlertEvent, removeAlertEvent } = eventSlice.actions;